import React from 'react';
import {
  ListItemIcon,
} from '@mui/material';
import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuButton,
  useContextMenu,
  ContextMenuItemType,
} from '@marageti/z4-lib';

type Props = {
  id: string;
  items: ContextMenuItemType[];
  customButtonIcon?: React.ReactNode;
};

const ContextMenuComplete = ({
  id,
  items,
  customButtonIcon,
}: Props) => {
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();
  const buttonId = `${id}-context-button`;
  const menuId = `${id}-context-menu`;

  const onClickItem = (action: (() => void)) => {
    action();
    setContextMenuAnchor(null);
  };

  return (
    <>
      <ContextMenuButton
        id={buttonId}
        menuId={menuId}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setContextMenuAnchor(e.currentTarget); }}
        open={contextMenuOpen}
      >
        {customButtonIcon}
      </ContextMenuButton>
      <ContextMenu
        anchorEl={contextMenuAnchor}
        buttonId={buttonId}
        id={menuId}
        onClose={(e) => { e.stopPropagation(); e.preventDefault(); setContextMenuAnchor(null); }}
        open={contextMenuOpen}
      >
        {items.map((item) => (
          <ContextMenuItem
            key={item.label}
            disabled={item.disabled}
            onClick={(e) => { e.stopPropagation(); onClickItem(item.action); }}
            sx={item.sx}
          >
            {item.icon && (
              <ListItemIcon>
                {item.icon}
              </ListItemIcon>
            )}
            {item.label}
          </ContextMenuItem>
        ))}
      </ContextMenu>
    </>
  );
};

export default ContextMenuComplete;
